// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as UserProfileType from "../../../app/entity/UserProfileType.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as SendSMSAssetsManager from "../../assets/SendSMSAssetsManager.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";

SendSMSAssetsManager.importCss(undefined);

var send_icon = SendSMSAssetsManager.getImage("send-small-icon.svg");

function UserCard(Props) {
  var handle_click = Props.handle_click;
  var selectedOpt = Props.selected;
  var userData = Props.userData;
  var index = Props.index;
  var handle_send_message_click = Props.handle_send_message_click;
  var selected = selectedOpt !== undefined ? selectedOpt : false;
  var getCardProfileTagCss = function (profile) {
    var match = UserProfileType.fromString(profile);
    if (match !== 1) {
      if (match >= 4) {
        return "user-unverified";
      } else {
        return "";
      }
    } else {
      return "user-partner";
    }
  };
  var mobileNumber = userData.secondary_mobile_number;
  return React.createElement("div", {
              className: "c-user-card " + (
                selected ? "selected " : ""
              ),
              onClick: (function (param) {
                  return Curry._2(handle_click, index, userData.primary_mobile_number);
                })
            }, React.createElement("div", {
                  className: "user-info-container"
                }, React.createElement("div", {
                      className: "c-user-selection-tag " + getCardProfileTagCss(userData.profile)
                    }, UserProfileType.displayString(userData.profile)), React.createElement("label", {
                      className: "user-name"
                    }, userData.name), React.createElement("label", {
                      className: "user-card-dash-text"
                    }, "-"), React.createElement("div", {
                      className: "user-contact-info-section"
                    }, React.createElement("div", {
                          className: "user-contact-title"
                        }, "Primary"), React.createElement("div", {
                          className: "user-contact-number"
                        }, userData.primary_mobile_number)), React.createElement("div", {
                      className: "user-contact-info-section"
                    }, React.createElement("div", {
                          className: "user-contact-title"
                        }, "Secondary"), React.createElement("div", {
                          className: "user-contact-number"
                        }, mobileNumber !== undefined ? mobileNumber : "N/A"))), React.createElement(PrimaryButton$Catalyst.make, {
                  buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                        TAG: /* Custom */1,
                        _0: (function (param) {
                            return React.createElement(React.Fragment, undefined, React.createElement("p", {
                                            className: userData.primary_mobile_number === "N/A" ? "disable-message" : ""
                                          }, "Send Message"), React.createElement("img", {
                                            className: userData.primary_mobile_number === "N/A" ? "disable-send-icon" : "",
                                            src: send_icon
                                          }));
                          })
                      }, userData.primary_mobile_number === "N/A", (function (_event) {
                          Curry._2(handle_click, index, userData.primary_mobile_number);
                          return Curry._1(handle_send_message_click, undefined);
                        }), undefined, undefined, undefined, undefined, "send-message-button\n          " + (
                        userData.primary_mobile_number === "N/A" ? "disable-send-button" : ""
                      ), undefined, undefined)
                }));
}

var make = UserCard;

export {
  send_icon ,
  make ,
  
}
/*  Not a pure module */
